export const serviziTCB = [
  {
    title: 'ORIENTAMENTO E CONSULENZA',
    value: "Per conoscere meglio il servizio di assistenza familiare per capire insieme ai\nnostri operatori qual è il servizio domiciliare più adatto alle tue\nesigenze, per scoprire se ci sono contributi e agevolazioni di cui puoi\nusufruire per l’assistenza familiare o per richiedere un preventivo\npersonalizzato sulla base delle tue esigenze.",
  },
  {
    // title: 'SUPPORTO ALLA CONTRATTUALIZZAZIONE',
    value: 'Per ricevere informazioni sulle pratiche per l’assunzione e sui soggetti\ncompetenti per la gestione del rapporto lavorativo (buste paga, calcolo\ntredicesima e TFR, etc).',
  },
  // {
  //   title: 'TUTORING',
  //   value: 'Per affrontare questioni legate ai tuoi familiari da assistere, alla\nrelazione con l’assistente familiare assunto/a o all’inserimento di un\nnuovo assistente familiare, grazie alla mediazione di un nostro\noperatore presso il tuo domicilio o presso la sede di WeMi Tate Colf\nBadanti.',
  // },
  // {
  //   title: 'EDUCAZIONE FINANZIARIA ',
  //   value: 'Per ricevere informazioni, consulenza, accompagnamento e supporto\nnell’individuare le migliori soluzioni per sostenere i costi dell’assistenza\ne della cura.',
  // },
  {
    title: 'BONUS ASSISTENZA FAMILIARE (BAF)',
    value: 'Per ricevere informazioni su come richiedere il Bonus Assistenza\nFamiliare (BAF) erogato da Regione Lombardia a favore delle persone e\ndelle famiglie che necessitano di assistenti iscritti ai Registri territoriali\ndegli Assistenti Familiari.',
  },
];
